import gsap from 'gsap'

const isTouchDevice = () => {
	return (
		'ontouchstart' in window ||
		navigator.maxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0 ||
		window.matchMedia("(pointer: coarse)").matches
	);
};

function getScale(element) {
	// Get the computed style of the element
	const style = window.getComputedStyle(element);
	// Get the transform matrix from the style
	const transform = style.transform || style.webkitTransform || style.mozTransform;
	// If there is no transform, return the default scale of 1
	if (!transform || transform === 'none') {
		return 1;
	}
	// Parse the matrix values
	const matrix = transform.match(/^matrix\((.+)\)$/);
	if (matrix) {
		// Split the matrix values and return the scale (a = matrix[1])
		const values = matrix[1].split(', ');
		const scaleX = parseFloat(values[0]);
		// Assuming uniform scaling, you can return scaleX
		return scaleX;
	}
	// Parse the matrix3d values
	const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
	if (matrix3d) {
		// Split the matrix3d values and return the scale (a = matrix3d[0])
		const values = matrix3d[1].split(', ');
		const scaleX = parseFloat(values[0]);
		// Assuming uniform scaling, you can return scaleX
		return scaleX;
	}
	// If no valid transform matrix is found, return the default scale of 1
	return 1;
}


function followingCursor() {
	//console.log('followingCursor function called');

	// Check for touch devices
	if ( isTouchDevice() ) {
		//console.log('Touch device detected, skipping cursor following');
		const videoCursor = document.querySelectorAll('[data-name="video-cursor"]');
		
		if ( videoCursor ) {
			videoCursor.forEach(cursor => {
				gsap.set(videoCursor, {xPercent: -50, yPercent: -50});
				gsap.set(videoCursor, { autoAlpha: 1 });
			});
		}
		return;
	}

	// Look for video blocks with play buttons
	const videoBlocks = document.querySelectorAll('[data-name="video"]');
	//console.log('Found video blocks:', videoBlocks.length);

	if ( videoBlocks.length === 0 ) {
		//console.log('No video blocks found');
		return;
	}

	videoBlocks.forEach((videoBlock, index) => {
		//console.log(`Processing video block ${index}:`, videoBlock);
		const videoCursor = videoBlock.querySelector('[data-name="video-cursor"]');
		//console.log('videoCursor found:', videoCursor);

		let insideVideo = false;
		let lastMouseX = 0;
		let lastMouseY = 0;

		if ( videoCursor ) {
			//console.log('Setting up cursor following for element:', videoCursor);
			//gsap.set(videoCursor, {xPercent: -50, yPercent: -50});
			gsap.set(videoCursor, { autoAlpha: 0 });

			let xTo = gsap.quickTo(videoCursor, 'x', {duration: 0.3, ease: 'power2.out', force3D: true});
			let yTo = gsap.quickTo(videoCursor, 'y', {duration: 0.3, ease: 'power2.out', force3D: true});

			// Helper function to check if mouse is within video bounds
			const isMouseInVideoBounds = () => {
				const rect = videoBlock.getBoundingClientRect();
				return lastMouseX >= rect.left &&
						lastMouseX <= rect.right &&
						lastMouseY >= rect.top &&
						lastMouseY <= rect.bottom;
			};

			const updateCursorPosition = () => {
				//console.log('Updating cursor position - insideVideo:', insideVideo);
				if (insideVideo) {
					const scale = getScale(videoBlock);
					const rect = videoBlock.getBoundingClientRect();

					const mouseX = (lastMouseX - rect.left) / scale;
					const mouseY = (lastMouseY - rect.top) / scale;

					gsap.to(videoCursor, { autoAlpha: 1, duration: 0.3 });

					xTo(mouseX - (videoBlock.clientWidth / 2));
					yTo(mouseY - (videoBlock.clientHeight / 2));

					if ( ! videoCursor.classList.contains('active') ) {
						videoCursor.classList.add('active');
					}
				} else {
					//xTo(0);
					//yTo(0);
					gsap.to(videoCursor, { autoAlpha: 0, duration: 0.3 });
					
					if ( videoCursor.classList.contains('active') ) {
						videoCursor.classList.remove('active');
					}
				}
			};

			// Mouse move handler
			const handleMouseMove = (e) => {
				lastMouseX = e.clientX;
				lastMouseY = e.clientY;
				updateCursorPosition();
			};

			// Scroll handler - only update position if still inside video
			const handleScroll = () => {
				if (insideVideo) {
					// Check if mouse is still within bounds after scroll
					const mouseInBounds = isMouseInVideoBounds();
					//console.log('Scroll detected - insideVideo:', insideVideo, 'mouseInBounds:', mouseInBounds);
					if (mouseInBounds) {
						updateCursorPosition();
					} else {
						// Mouse is no longer in video bounds due to scroll
						insideVideo = false;
						updateCursorPosition();
					}
				}
			};

			// Mouse enter handler
			const handleMouseEnter = () => {
				//console.log('Mouse entered video');
				insideVideo = true;
				updateCursorPosition();
			};

			// Mouse leave handler - this handles when mouse physically leaves the element
			const handleMouseLeave = () => {
				//console.log('Mouse left video');
				insideVideo = false;
				updateCursorPosition();
			};

			// Add event listeners
			window.addEventListener('mousemove', handleMouseMove);
			window.addEventListener('scroll', handleScroll);
			videoBlock.addEventListener('mouseenter', handleMouseEnter);
			videoBlock.addEventListener('mouseleave', handleMouseLeave);

			// Cleanup function (optional - for removing event listeners if needed)
			videoBlock._cleanupCursorEvents = () => {
				window.removeEventListener('mousemove', handleMouseMove);
				window.removeEventListener('scroll', handleScroll);
				videoBlock.removeEventListener('mouseenter', handleMouseEnter);
				videoBlock.removeEventListener('mouseleave', handleMouseLeave);
			};
		}
	});
}

export { followingCursor };